export let StartChatFailureType;
(function (StartChatFailureType) {
  StartChatFailureType["Unauthorized"] = "unauthorized";
  StartChatFailureType["AuthSetupError"] = "authSetupError";
  StartChatFailureType["Generic"] = "generic";
})(StartChatFailureType || (StartChatFailureType = {}));